import { getFullDate, isSameDay, getTime, dateWithTime } from '@utils/dates';
import { getAuthorFullName } from '@api/processors/search';
import { programmeTypes } from '@constants/index';
import { pluralize } from '@utils/textHelper';

export const getIsCourseHybridNonOffline = (programme = {}) =>
  programme?.programmeType === programmeTypes.HYBRID_NON_OFFLINE;

export const getIsOnlyRecordedClassesPresent = (programme = {}) =>
  programme?.programmeType === programmeTypes.HYBRID_NON_OFFLINE &&
  !programme?.isLiveClassPresent;

export const getAuthorInfo = (course = {}) => {
  const { author, authors } = course;
  let authorID = authors?.[0]?.user?.relative_link || author?.relativeLink;
  if (!authorID && (authors?.[0]?.username || author?.username))
    authorID = `/@${authors?.[0]?.username || author?.username}`;
  const authorName = authors?.[0]?.name || getAuthorFullName(author);
  return { authorID, authorName };
};

export const getLiveAtTIme = (liveAtString) => {
  return liveAtString ? getTime(liveAtString) : '';
};

export const getCourseInfo = (hideLessonCount, course = {}) => {
  const {
    isOngoing,
    isCompleted,
    isUpcoming,
    isLive,
    nextTrack,
    programme,
    isSpecial,
    itemCount
  } = course;
  const isCourseHybridNonOffline =
    getIsCourseHybridNonOffline(programme) ||
    getIsCourseHybridNonOffline(course);
  const isOnlyRecordedClassesPresent =
    getIsOnlyRecordedClassesPresent(programme) ||
    getIsOnlyRecordedClassesPresent(course);
  const totalSessionString = `${pluralize(itemCount, 'session')}`;

  if (isOnlyRecordedClassesPresent && !isSpecial) return totalSessionString;

  if (!nextTrack && !isCourseHybridNonOffline) return '';
  const liveLessonRank = nextTrack?.rank;
  const liveAtString = nextTrack?.liveAtString || nextTrack?.properties?.liveAt;
  const liveLessonStartTime = new Date(liveAtString);
  const lessonCountString = liveLessonRank
    ? `Lesson ${liveLessonRank}`
    : totalSessionString;

  if (
    !isCourseHybridNonOffline &&
    (liveLessonRank === undefined || Number.isNaN(+liveLessonStartTime))
  ) {
    return '';
  }
  if (isLive) {
    return `${lessonCountString} • Started at ${getLiveAtTIme(liveAtString)}`;
  }
  if (isOngoing) {
    const isToday = isSameDay(liveLessonStartTime, new Date());
    if (isToday)
      return `${lessonCountString} • Today, ${getLiveAtTIme(liveAtString)}`;
    return `${lessonCountString} • ${getFullDate(liveAtString)} ${getLiveAtTIme(
      liveAtString
    )}`;
  }
  if (isUpcoming) {
    const { itemCount: totalLessons, liveClassCount, startsAt } = course;
    if (isSpecial || hideLessonCount)
      return `Starts on ${dateWithTime(startsAt)}`;
    return `Starts on ${getFullDate(startsAt)} • ${
      totalLessons || liveClassCount || 0
    } lessons`;
  }
  if (isCompleted) {
    const { itemCount: totalLessons, liveClassCount, endsAt } = course;
    if (isSpecial || hideLessonCount) return `Ended on ${getFullDate(endsAt)}`;
    return `Ended on ${getFullDate(endsAt)} • ${
      totalLessons || liveClassCount || 0
    } lessons`;
  }
  return '';
};
